import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOMedicineCommonNameType } from "../models/BOMedicineCommonNameType.model";

@Injectable()
export class MedicineCommonNameTypeService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/medicationCommonNameType';

    constructor(private http:HttpClient){}

    getAll(medicationFilter:string):Observable<BOMedicineCommonNameType[]>{
        return this.http.get<BOMedicineCommonNameType[]>(this.myAppUrl + this.myApiUrl +'/'+ medicationFilter);
    }
}
